module.exports = __webpack_public_path__ + "img/sketch.248f373e.svg";